<template>
  <div class="match-invite-page">
    <Breadcrumb :type="breadcrumbType"></Breadcrumb>
    <div class="company-content">
      <img
        src="@/assets/images/icon-21.png"
        v-if="categoryId == '123'"
        alt=""
        class="icon-image"
      />
      <img
        src="@/assets/images/icon-42.png"
        v-else-if="!isResourceDetail"
        alt=""
        class="icon-image"
      />

      <template v-if="showResourceList">
        <div class="resource-list">
          <div
            class="resource-item"
            v-for="(item, index) in newsList"
            :key="item.articleId || index"
            @click="openResourceDetail(item)"
          >
            <div class="resource-card">
              <div class="resource-image">
                <img
                  :src="item.cover || defaultResourceCover"
                  alt=""
                  class="image"
                />
              </div>
              <div class="resource-body">
                <div class="resource-title">{{ item.articleName }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-else-if="detailList.length > 0">
        <div>
          <div
            class="company-row"
            v-for="(item, index) in detailList"
            :key="item.articleId || index"
            :class="index % 2 != 0 ? 'company-row-active' : ''"
          >
            <div class="company-image">
              <img class="image" :src="item.cover" alt="logo" />
            </div>
            <div class="company-flex"></div>
            <div class="company-message">
              <div class="message-title">
                {{ item.articleName }}
              </div>
              <div class="desc" v-html="item.articleContent"></div>
            </div>
          </div>
        </div>
      </template>

      <el-empty
        description="暂无数据"
        v-if="showResourceList && newsList.length == 0"
      ></el-empty>
      <el-empty
        description="暂无数据"
        v-if="!showResourceList && detailList.length == 0 && !detailLoading"
      ></el-empty>
    </div>
  </div>
</template>

<script>
import { getArticleById, getArticlePage } from '@/api/home/home.js'
import Breadcrumb from '@/components/common/breadcrumb'
import { fixMedia } from '@/utils/util'
import defaultResourceCover from '@/assets/images/icon-41.png'

export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      categoryId: '',
      resourceId: '',
      defaultResourceCover,
      newsList: [],
      selectedArticle: null,
      detailLoading: false
    }
  },
  computed: {
    breadcrumbType() {
      return this.isResourceDetail ? 3 : 1
    },
    isResourceCategory() {
      return this.categoryId == '130'
    },
    isResourceDetail() {
      return this.isResourceCategory && !!this.resourceId
    },
    showResourceList() {
      return this.isResourceCategory && !this.resourceId
    },
    detailList() {
      if (this.isResourceCategory) {
        return this.selectedArticle ? [this.selectedArticle] : []
      }
      return this.newsList
    }
  },
  created() {
    this.initPage()
  },
  watch: {
    '$route.fullPath'() {
      this.initPage()
    }
  },
  methods: {
    initPage() {
      this.categoryId = this.$route.query?.categoryId || ''
      this.resourceId = this.$route.query?.resourceId || ''
      this.newsList = []
      this.selectedArticle = null
      this.getArticleList()
    },
    getArticleList() {
      getArticlePage({
        page: 1,
        limit: 10000,
        categoryCode: this.categoryId
      }).then((res) => {
        if (!res.data) return
        this.newsList = res.data.list || []

        if (!this.isResourceDetail) return

        const currentArticle = this.newsList.find((item) => {
          return String(item.articleId) == String(this.resourceId)
        })

        if (currentArticle) {
          this.selectedArticle = {
            ...currentArticle,
            articleContent: fixMedia(currentArticle.articleContent)
          }
        }

        this.getArticleDetail(this.resourceId)
      })
    },
    getArticleDetail(id) {
      if (!id) return
      this.detailLoading = true
      getArticleById(id)
        .then((res) => {
          if (!res.data) return
          this.selectedArticle = {
            ...res.data,
            articleContent: fixMedia(res.data.articleContent)
          }
        })
        .finally(() => {
          this.detailLoading = false
        })
    },
    openResourceDetail(item) {
      this.$router.push({
        path: '/base/introduction',
        query: {
          ...this.$route.query,
          resourceId: item.articleId
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.match-invite-page {
  display: flex;
  flex-direction: column;

  .company-content {
    display: flex;
    flex-direction: column;
    width: 1340px;
    margin: 34px auto 100px;

    .resource-list {
      display: flex;
      flex-wrap: wrap;
      gap: 32px;

      .resource-item {
        display: flex;
        flex-direction: column;
        width: calc((100% - 96px) / 4);
        cursor: pointer;
        background: #ffffff;
        border-radius: 16px;
        border: 1px solid #e5e7eb;
        overflow: hidden;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
        transform: translateY(0);
        transition: box-shadow 0.35s ease, border-color 0.35s ease,
          transform 0.35s ease;

        .resource-card {
          display: flex;
          flex-direction: column;
          min-height: 100%;
          background: #ffffff;
        }

        .resource-image {
          height: 170px;
          background: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;

          .image {
            width: 100%;
            height: 170px;
            display: block;
            object-fit: cover;
          }
        }

        .resource-body {
          display: flex;
          align-items: center;
          min-height: 88px;
          padding: 20px 18px;
          background: #f9fafb;
        }

        .resource-title {
          color: #1e293b;
          font-size: 16px;
          line-height: 24px;
          font-weight: 600;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-all;
        }
      }

      .resource-item:hover {
        border-color: #bfdbfe;
        box-shadow: 0 12px 36px rgba(0, 0, 0, 0.12);
        transform: translateY(-4px);
      }
    }

    .company-row {
      display: flex;
      flex-direction: row;
      margin-top: 48px;

      .company-message {
        flex: 1;
        display: flex;
        flex-direction: column;

        .message-title {
          min-height: 60px;
          line-height: 60px;
          color: #1b56a9;
          font-size: 28px;
          font-weight: 600;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }

        .desc {
          font-size: 20px;
          color: #333;
          line-height: 35px;
        }
      }

      .company-flex {
        width: 64px;
      }

      .company-image {
        width: 650px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .image {
          width: 650px;
          height: 428px;
          object-fit: cover;
        }
      }
    }

    .company-row-active {
      flex-direction: row-reverse;
    }

    .company-row:nth-child(n + 2) {
      margin-top: 64px;
    }

    .icon-image {
      width: 362px;
      height: 64px;
      margin: 0 auto 34px;
      object-fit: cover;
    }
  }
}

.mobile-content {
  .match-invite-page {
    .company-content {
      width: 345px;
      margin: 32px auto 60px;

      .resource-list {
        gap: 15px;

        .resource-item {
          width: calc(50% - 7.5px);
          border-radius: 12px;

          .resource-image {
            height: 150px;

            .image {
              height: 150px;
            }
          }

          .resource-body {
            min-height: 64px;
            padding: 14px 12px;
          }

          .resource-title {
            font-size: 13px;
            line-height: 20px;
          }
        }
      }

      .company-row-active {
        flex-direction: column;
      }

      .company-row {
        display: flex;
        flex-direction: column;
        margin-top: 20px;

        .company-message {
          margin-left: 0;

          .message-title {
            min-height: 30px;
            line-height: 30px;
            font-size: 20px;
            margin-top: 20px;
          }

          .desc {
            font-size: 14px;
            line-height: 24px;
            margin-top: 10px;
          }
        }

        .company-image {
          width: 345px;

          .image {
            width: 345px;
            height: 250px;
          }
        }
      }

      .icon-image {
        width: 250px;
        height: 38.4px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
